
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servizi",
      function () {
        return require("private-next-pages/servizi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servizi"])
      });
    }
  